function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(6.12323e-17 1 -1 6.12323e-17 512.016 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M496.008,79.997h-368v-48c0-6.464-3.904-12.32-9.888-14.784s-12.832-1.088-17.44,3.456l-96,96    c-6.24,6.24-6.24,16.384,0,22.624l96,96c4.608,4.576,11.456,5.952,17.44,3.488s9.888-8.32,9.888-14.784v-48h368    c8.832,0,16-7.168,16-16v-64C512.008,87.133,504.84,79.997,496.008,79.997z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507.336,372.701l-96-96.032c-4.576-4.576-11.456-5.952-17.44-3.456c-5.984,2.496-9.888,8.32-9.888,14.784v48h-368    c-8.832,0-16,7.168-16,16v64c0,8.832,7.168,16,16,16h368v48c0,6.464,3.904,12.32,9.888,14.784    c5.984,2.496,12.864,1.12,17.44-3.456l96-96C513.576,389.085,513.576,378.941,507.336,372.701z"
}));

var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512.016 512.016",
    width: "15px",
    height: "15px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.dab8bb35.svg";
export { ForwardRef as ReactComponent };